// extracted by mini-css-extract-plugin
export default {"wrapper":"tab1_wrapper__dBYj6"};